
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LineRedirect from "../pages/LineRedirect";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/line-redirect",
    element: <LineRedirect />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
